module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-10-02afeaa10f310cb1f2a6c25fccb295a8.jpg";